"use client";

// Package Imports
import React from 'react';
import Image from "next/image";
import Link from "next/link";

// Style Imports
import styles from "./hero.module.scss";
import classNames from 'classnames';
interface HeroProps {
  src: string;
  alt?: string;
  url?: string;
  srcMedium?: string;
  srcSmall?: string;
  border?: boolean;
}

/**
 * A responsive component to display 2 featured banners.
 *
 * @param src - The image source to display in the hero
 * @param alt - The alt tag for the image
 * @param url - The url the hero should link to
 * @param srcMedium - The medium-sized source to display in the hero
 * @param srcSmall - The small-sized source to display in the hero
 * @param border - Display a border on the bottom
 */

const Hero: React.FC<HeroProps> = ({ src, alt, url, srcMedium, srcSmall, border }) => {
  const medium = srcMedium ? srcMedium : src;
  const small = srcSmall ? srcSmall : srcMedium ? srcMedium : src;
  const wrapWithLink = (imageElement: React.ReactElement) =>
    url ? <Link href={url}>{imageElement}</Link> : imageElement;
  return (
    <section className={classNames(styles.hero, { [styles.border]: border })}>
      {wrapWithLink(
        <Image
          src={src}
          width={1920}
          height={449}
          alt={alt || ''}
          className={styles.heroLarge}
        />
      )}
      {wrapWithLink(
        <Image
          src={medium}
          width={1000}
          height={272}
          alt={alt || ''}
          className={styles.heroMedium}
        />
      )}
      {wrapWithLink(
        <Image
          src={small}
          width={768}
          height={400}
          alt={alt || ''}
          className={styles.heroSmall}
        />
      )}
    </section>
  );
};

export default Hero;
